import posthog from 'posthog-js'
import { useLocation } from 'react-router-dom'

import LaunchIcon from '@src/components/icons/Launch'
import * as PATH from '@src/configs/paths'
import { useExchangeDataContext } from '@src/pages/Exchange/context/ExchangeDataContext'

interface ISwapModalFooterProps {
    transactionHash?: string
    isSwapCompleted?: boolean
    enableNewTxButton?: boolean
    onClose?: () => void
}

export default function SwapModalFooter({
    transactionHash = '',
    isSwapCompleted = false,
    enableNewTxButton = true,
    onClose,
}: ISwapModalFooterProps) {
    /**
     * * * * * * * * * * * * * * * * * * * * * NEW EXCHANGE DATA CONTEXT * * * * * * * * * * * * * * *
     */
    const { sellData, updateSellData, buyData, updateBuyData } = useExchangeDataContext()
    const { pathname } = useLocation()
    const isEmbedMode = pathname === PATH.EMBED
    /**
     * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
     */

    const handleNewTransaction = (e: React.MouseEvent) => {
        // Prevent default to avoid page navigation
        e.preventDefault()

        // Reset sell and buy data to initial state
        updateSellData({ ...sellData, value: BigInt(0) })
        updateBuyData({ ...buyData, value: BigInt(0) })

        // Close the modal if onClose prop is provided
        if (onClose) {
            onClose()
        }
    }

    return (
        <div className='swap-footer-container flex gap-3'>
            {!isSwapCompleted ? (
                <a
                    href={transactionHash}
                    target='_blank'
                    rel='noreferrer'
                    className='swap-footer-link flex items-center gap-2 rounded-lg border border-[#313339] px-3 py-2 text-xs font-medium text-[#959699] md:px-[18px] md:py-4 md:text-sm'
                >
                    View on block explorer
                    <LaunchIcon className='h-3 w-3 md:h-4 md:w-4' />
                </a>
            ) : (
                <a
                    href={isEmbedMode ? `${PATH.APP}/${PATH.ORDERS}` : PATH.ORDERS}
                    {...(isEmbedMode && {
                        target: '_blank',
                        rel: 'noopener noreferrer',
                    })}
                    className='swap-footer-link flex items-center gap-2 rounded-lg border border-[#313339] px-3 py-2 text-xs font-medium text-[#959699] md:px-[18px] md:py-4 md:text-sm'
                >
                    View on Orders page
                    <LaunchIcon className='h-3 w-3 md:h-4 md:w-4' />
                </a>
            )}
            {enableNewTxButton && (
                <button
                    onClick={handleNewTransaction}
                    className='swap-footer-button flex flex-grow items-center justify-center gap-2 rounded-lg border border-none bg-primary p-2 text-xs font-medium md:p-4 md:text-sm'
                >
                    New Transaction
                </button>
            )}
        </div>
    )
}
